import { render, staticRenderFns } from "./projectlist.vue?vue&type=template&id=13fdc01f&scoped=true&"
import script from "./projectlist.vue?vue&type=script&lang=js&"
export * from "./projectlist.vue?vue&type=script&lang=js&"
import style0 from "./projectlist.vue?vue&type=style&index=0&id=13fdc01f&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fdc01f",
  null
  
)

export default component.exports